import { createApp } from "vue";
//import Vue from 'vue'
import App from "./App.vue";
import router from "./router";
import RouterView  from "vue-router";
import i18n from '@/helper/i18n'
import {store} from '@/store'
import Paginate from "vuejs-paginate-next";
//import { BootstrapVue, TablePlugin } from "bootstrap-vue";
import Loading from 'vue3-loading-overlay';
import excel from 'vue-excel-export'
import {dom, library} from '@fortawesome/fontawesome-svg-core';
import { fas } from '@fortawesome/free-solid-svg-icons'
library.add(fas);
dom.watch()


// createApp(App).mount("#app");
import '../node_modules/admin-lte/dist/css/adminlte.min.css'
import '../node_modules/admin-lte/plugins/icheck-bootstrap/icheck-bootstrap.min.css'
import "../node_modules/admin-lte/plugins/select2-bootstrap4-theme/select2-bootstrap4.min.css"
import "../node_modules/admin-lte/plugins/select2/css/select2.min.css"
import '../node_modules/vue3-loading-overlay/dist/vue3-loading-overlay.css';

import "../node_modules/admin-lte/plugins/jquery/jquery.min.js"
import "../node_modules/admin-lte/plugins/bootstrap/js/bootstrap.bundle.min.js"
import "../node_modules/admin-lte/plugins/overlayScrollbars/js/jquery.overlayScrollbars.min.js"
import "../node_modules/admin-lte/plugins/select2/js/select2.full.min.js"
import "../node_modules/admin-lte/dist/js/adminlte.js"


const app = createApp(App);
app.config.productionTip = false;
app.use(router);
app.use(store);
app.use(i18n);
app.use(RouterView);
app.use(excel);
app.use(Paginate);
app.use(Loading, {
    // props
    color: 'red'
  });
app.mount('#app')